import { render } from "./JumpToWeapp.vue?vue&type=template&id=6d231c70&scoped=true&ts=true&lang=pug"
import script from "./JumpToWeapp.vue?vue&type=script&lang=ts"
export * from "./JumpToWeapp.vue?vue&type=script&lang=ts"

import "./JumpToWeapp.vue?vue&type=style&index=0&id=6d231c70&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d231c70"]])

export default __exports__